import { WeekdayOrdinal } from '../../../features/calendar/calendar-types';

export class GlobalAppConfigModel {
  public weekStartsOn: WeekdayOrdinal = null;
  public workTimeStart = '';
  public workTimeEnd = '';
}
